function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import find from 'lodash/find';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import { useAction } from 'hooks';
import Modal from 'components/Modal';
import App from 'modules/App';
import BackButton from 'components/BackButton';
import VisitsHistory from 'modules/Visit/partials/VisitsHistory';
import VisitNotesMessenger from 'modules/Visit/partials/VisitNotesMessenger';
import Table from 'components/Table';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './VisitHistoryModal.pcss';
import useTableSchema from './useTableSchema';
const VisitHistoryModal = ({ mode, onFetchNotes, onStoreNotes })=>{
    useStyles(styles);
    const visits = useSelector(selectors.visits);
    const openModalId = useSelector(App.selectors.modal);
    const openModalIdRef = useRef(openModalId);
    const [view, setView] = useState('visits');
    const [selectedVisit, setSelectedVisit] = useState(null);
    const closeModal = useAction(App.actions.closeModal);
    const onShowNotes = useCallback((visit)=>{
        onFetchNotes(visit);
        setView('notes');
        setSelectedVisit(visit);
    }, [
        onFetchNotes
    ]);
    const onBack = useCallback((evt = null)=>{
        if (evt) {
            evt.preventDefault();
        }
        setView('visits');
        setSelectedVisit(null);
    }, []);
    const schema = useTableSchema(mode, visits, onShowNotes);
    useEffect(()=>()=>{
            onBack();
        }, []);
    useEffect(()=>()=>{
            if (openModalIdRef.current === constants.VISIT_HISTORY_MODAL && !openModalId) {
                onBack();
            }
            openModalIdRef.current = openModalId;
        }, [
        openModalId
    ]);
    const renderHeader = ()=>{
        const headerMessage = messages.headers[view === 'visits' ? 'visitHistory' : 'visitNotes'];
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                view !== 'visits' && /*#__PURE__*/ _jsx(BackButton, {
                    className: "mb-7 d-flex align-items--center",
                    to: "",
                    onClick: onBack
                }),
                /*#__PURE__*/ _jsx("h2", {
                    className: "text--h1 mb-4",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, headerMessage))
                })
            ]
        });
    };
    const renderContent = ()=>{
        if (view === 'visits') {
            return /*#__PURE__*/ _jsx(VisitsHistory, {
                mode: mode,
                onShowNotes: onShowNotes,
                children: ({ phiSetVisits, page, perPage, isInProgress, onPageChange })=>/*#__PURE__*/ _jsx(Table, {
                        idKey: "phisetVisitId",
                        className: styles.table,
                        schema: schema,
                        entities: phiSetVisits,
                        page: page,
                        perPage: perPage,
                        isInProgress: isInProgress,
                        isPerPageOff: true,
                        onPageChange: onPageChange
                    })
            });
        }
        const phisetVisitId = selectedVisit === null || selectedVisit === void 0 ? void 0 : selectedVisit.phisetVisitId;
        const visit = find(visits, {
            phisetVisitId
        });
        return /*#__PURE__*/ _jsx(VisitNotesMessenger, {
            selectedVisit: visit,
            mode: mode,
            onStoreNotes: onStoreNotes
        });
    };
    return /*#__PURE__*/ _jsx(Modal, {
        modalId: constants.VISIT_HISTORY_MODAL,
        styleModifier: "lg",
        openModalId: openModalId,
        onClose: closeModal,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.modalViewContainer,
            children: [
                renderHeader(),
                renderContent()
            ]
        })
    });
};
export default VisitHistoryModal;
